module.exports = __webpack_public_path__ + "static/media/herbs.3fb95808.png";